import { render, staticRenderFns } from "./wf-outlined-checkbox-list-display.vue?vue&type=template&id=efe66216&scoped=true&"
import script from "./wf-outlined-checkbox-list-display.vue?vue&type=script&lang=ts&"
export * from "./wf-outlined-checkbox-list-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-outlined-checkbox-list-display.vue?vue&type=style&index=0&id=efe66216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe66216",
  null
  
)

export default component.exports